import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ClinicalInformationPacimService } from '@core/service';
import { SubSink } from 'subsink';
import { PacimAuthorizationType } from '@core/enumeration';
import { FormBaseData, FormioFormConfig } from '@mynexus/mynexus-ui-lib';


@Component({
    selector: 'clinical-information-detail',
    templateUrl: './clinical-information-detail.component.html',
    styleUrls: ['./clinical-information-detail.component.scss'],
    standalone: false
})
export class ClinicalInformationDetailComponent implements OnInit {
  @Input() tenantId!: string;
  @Input() serviceLineType!: string;
  @Input() authorizationType!: string;
  @Input() clinicalInformation: FormBaseData;
  @Input() isPASComplete: boolean;
  @Input() isCSR: boolean;

  formConfig: FormioFormConfig = null;
  formData: FormBaseData = null;

  get isTabAvailable() {
    return this.authorizationType === PacimAuthorizationType.SNF || !this.isCSR;
  }

  private readonly subs = new SubSink();

  constructor(
    private readonly clinicalInfoService: ClinicalInformationPacimService,
    private readonly ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.isTabAvailable && this.clinicalInformation) {
      this.formData = {
        data: { ...this.clinicalInformation.form.submission },
      };

      this.getForm();
    }
  }

  onFormReady(form: any): void {
    form.isLoading = false;
  }

  private getForm(): void {
    this.subs.sink = this.clinicalInfoService
      .fetchLatestRevisionForm(
        this.tenantId,
        this.authorizationType as PacimAuthorizationType,
        this.serviceLineType,
      )
      .subscribe((res) => {
        const submitButton = res.components.find((c) => c.key === 'submit');

        if (submitButton) {
          submitButton.hidden = true;
        }

        this.formConfig = res;
        this.ref.markForCheck();
      });
  }
}
